import { PageBillingType } from '@mm/state/interfaces/connected-page';
import { useSelector } from 'react-redux';
import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';

export const NEW_PRICING_FILTERING_LEVEL = 3;

export const BillingTypeLevelDict = {
  [PageBillingType.Free]: 1,
  [PageBillingType.Promotion]: 1,
  [PageBillingType.WP]: 1,
  [PageBillingType.TrialTeam]: 1,

  [PageBillingType.LegacyPro]: 2,
  [PageBillingType.Pro]: 2,
  [PageBillingType.SpecialPro]: 2,
  [PageBillingType.CustomPro]: 2,

  [PageBillingType.ProUnicorn]: 3,

  [PageBillingType.LegacyTeam]: 4,
  [PageBillingType.Team]: 4,
  [PageBillingType.SpecialTeam]: 4,
  [PageBillingType.CustomTeam]: 4,
  [PageBillingType.NewTeam]: 4,
  [PageBillingType.TeamLabel]: 4,
};

const isPlanMatchingRequiredGroup = (
  plan: PageBillingType,
  requiredPlan: PageBillingType,
) => BillingTypeLevelDict[plan] >= BillingTypeLevelDict[requiredPlan];

export const useMatchBillingPlan = (requiredBillingType: PageBillingType) => {
  const activePage = useSelector(activeFacebookPageSelector);
  const currentPagePlan = activePage?.pageBillingType;

  return (
    currentPagePlan &&
    isPlanMatchingRequiredGroup(currentPagePlan, requiredBillingType)
  );
};

export const useAdjustedPricingBillingPlan = (
  requiredBillingType: PageBillingType,
) => {
  const { november2021Pricing } = useSelector(combinedFeatureFlagsSelector);

  const compareTo =
    !november2021Pricing ||
    (november2021Pricing &&
      BillingTypeLevelDict[requiredBillingType] > NEW_PRICING_FILTERING_LEVEL)
      ? BillingTypeLevelDict[requiredBillingType]
      : NEW_PRICING_FILTERING_LEVEL;

  return BillingTypeLevelDict[requiredBillingType] >= compareTo
    ? requiredBillingType
    : PageBillingType.ProUnicorn;
};
